module.exports = __webpack_public_path__ + "img/xiaomi-mi-8.2e45910a.jpg";